<template>
  <div>
    <button :class="{'footer-accordion' : true, 'active' : opened }" @click="toggleOpen()" v-html="heading" />
    <div class="panel" :style="{ 'display' : opened ? 'block' : 'none'}">
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    heading: {
      type: String,
      required: false,
      default: '',
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    locked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      opened: true,
    };
  },

  created() {
    this.opened = this.open;
  },

  methods: {

    toggleOpen() {
      if (this.locked === false) this.opened = !this.opened;
      this.$emit('changed', this.opened);
    },

  },
};

</script>

  <style lang="scss" scoped>
  @import "../assets/styles/settings/config.scss";

  .footer-accordion {
    font-size: 14px;
    letter-spacing: 0.7px;
    border-bottom: solid 1px $darkBlue;
    background-color: $darkBlack;
    color: $stoneWhite;
    cursor: pointer;
    min-height: 47px;
    width: 100%;
    // transition: 0.4s;
    display: flex;
    justify-content: space-between;
    align-items: center;

    // font styling
    text-transform: uppercase;
    font-weight: 500;
    padding: 0 2em;
    &.active {
      border: none;
      margin-bottom: 0;
    }
  }

   .footer-accordion:after {
    content: "";
    background-image: svg-load('icons/curved-chevron-down-light.svg');
    background-size: contain;
    height: 10px;
    width: 17px;
    float: right;
  }

  .active:after {
    content: "";
    background-image: svg-load('icons/curved-chevron-up-light.svg');
    background-size: contain;
    height: 10px;
    width: 17px;
    float: right;
  }

  /* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
  .footer-accordion:hover {
    background-color: $darkBlack;
  }

  /* Style the accordion panel. Note: hidden by default */
  .panel {
    background-color: $darkBlack;
    border-bottom: solid 1px $darkBlue;
    display: none;
    overflow: hidden;
    padding: 0 2em 2em;
    ul {
      line-height: 2.5;
    }
  }

  button {
    padding: 0;
  }

</style>
